import React ,{Component} from "react";
import {chunk} from "../helpers";
import {Col, Row} from "react-bootstrap";
import {fileProperties} from "../constants";

import Leaflet from "leaflet";
import "leaflet/dist/leaflet.css";
import {Map, TileLayer, Marker} from "react-leaflet";

delete Leaflet.Icon.Default.prototype._getIconUrl;

Leaflet.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});


class EstateTabs extends Component {
    render() {
        let file = this.props.file;
        let position = (file.latitude && file.longitude)
            ? [file.latitude, file.longitude]
            : [0, 0];

        const chunked = chunk(fileProperties, 4);

        return (
            <div className="tab-cont">
                <div className="tab-content current" id="tabs-1">
                    <div className="item info">
                        {chunked.map((item, index) => {
                            return (
                                <Row key={index}>
                                    <Col md={12} sm={6} xs={12}>
                                        <ul className="rest">
                                            {Object.keys(item).map((key, jIndex) => {
                                                if (file[key] == 1) {
                                                    return (
                                                        <li className="d-flex align-items-center mb-15" key={jIndex}>
                                                            <span className="text-u fw-500">{fileProperties[key]}</span>
                                                        </li>
                                                    );
                                                }
                                            })}
                                        </ul>
                                    </Col>
                                </Row>
                            );
                        })}
                    </div>
                </div>
                <div className="tab-content" id="tabs-2">
                    <div className="item">
                        <div className="bottom40">
                            <Row>
                                <Col md={12}>
                                    <div className="bottom20">
                                        <div className="property-list-map">
                                            <Map center={position} zoom={13} style={{width: "100%", height: "430px"}}>
                                                <TileLayer
                                                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                />
                                                <Marker position={position}> </Marker>
                                            </Map>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
                <div className="tab-content" id="tabs-3">
                    <div className="item info">
                        <ul className="rest">
                            <li className="d-flex align-items-center mb-15">
                                <span className="text-u fw-500">دفتر فروش</span>
                                <span className="line"> </span>
                                <span className="ml-auto">
                                    <a href={'tel:02142607777'}>021-42607777</a>
                                </span>
                            </li>
                            {this.props.agents.map((agent, key) => {
                                return (
                                    <li key={key} className="d-flex align-items-center mb-15">
                                        <span className="text-u fw-500">{agent.first_name ? (agent.first_name + ' ' + agent.last_name) : '-'}</span>
                                        <span className="line"> </span>
                                        <span className="ml-auto">
                                            {agent.landline
                                                ? <a href={'tel:' + agent.landline}>{agent.landline}</a>
                                                : '-'}
                                            {" | "}
                                            {agent.phone
                                                ? <a href={'tel:' + agent.phone}>{agent.phone}</a>
                                                : '-'}
                                        </span>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default EstateTabs;
